"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheProvider = void 0;
var preact_1 = require("preact");
var react_1 = require("@emotion/react");
var cache_1 = __importDefault(require("@emotion/cache"));
var emotionCache = (0, cache_1.default)({
    key: 'ss',
    prepend: true,
});
var CacheProvider = function (props) {
    return (0, preact_1.h)(react_1.CacheProvider, { value: props.cache || emotionCache }, props.children);
};
exports.CacheProvider = CacheProvider;
